<template>
  <!-- 用户信息 -->
  <div class="user-info">
    <div class="user-info-header">
      <!-- <p>用户信息:</p> -->
      <el-button
        tag="a"
        href="https://www.xinshu.pro"
        target="_blank"
        rel="noopener noreferrer"
        class="w-full"
        color="#E5EAF3"
        size="large"
      >
        病案管理系统
      </el-button>
      <el-dropdown class="user-dropdown">
        <el-button color="#E5EAF3" size="large">
          <el-icon>
            <User />
          </el-icon>
          <el-icon class="el-icon--right"><arrow-down /></el-icon>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              ><el-icon> <Location /> </el-icon>医院:
              {{ userInfo.hospital }}</el-dropdown-item
            >
            <el-dropdown-item
              ><el-icon> <Platform /> </el-icon>科室:
              {{ userInfo.keshi }}</el-dropdown-item
            >
            <el-dropdown-item
              ><el-icon> <UserFilled /> </el-icon>姓名:
              {{ userInfo.name }}</el-dropdown-item
            >
            <el-dropdown-item
              ><el-icon> <UserFilled /> </el-icon>性别:
              {{ userInfo.sex == "male" ? "男" : "女" }}</el-dropdown-item
            >
            <el-dropdown-item
              ><el-icon> <Compass /> </el-icon>职称:
              {{ userInfo.zhicheng }}</el-dropdown-item
            >
            <el-dropdown-item
              ><el-icon> <Iphone /> </el-icon>手机号:
              {{ userInfo.phone }}</el-dropdown-item
            >
            <el-dropdown-item @click="changepassword()"
              ><el-icon> <Monitor /> </el-icon>更改密码</el-dropdown-item
            >
            <el-dropdown-item @click="exit"
              ><el-icon> <Back /> </el-icon>退出</el-dropdown-item
            >
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>

  <!-- 修改个人信息对话框 -->
  <el-dialog v-model="userInfodialogVisible" width="96%">
    <el-form :model="userInfo" ref="form" :rules="rules" label-width="auto">
      <el-descriptions
        title="个人信息"
        direction="vertical"
        :column="4"
        :size="size"
        border
      >
        <el-descriptions-item label="医院">{{
          userInfo.hospital
        }}</el-descriptions-item>
        <el-descriptions-item label="姓名">{{
          userInfo.name
        }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{
          userInfo.sex == "male" ? "男" : "女"
        }}</el-descriptions-item>
        <el-descriptions-item label="科室">
          {{ userInfo.keshi }}</el-descriptions-item
        >
        <el-descriptions-item label="职称">
          <el-tag size="small">{{ userInfo.zhicheng }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="手机号"
          >{{ userInfo.phone }}
        </el-descriptions-item>
      </el-descriptions>

      <el-form-item
        label="旧密码"
        prop="password"
        :rules="[{ required: true, message: '请输入旧密码', trigger: 'blur' }]"
        class="mt-4"
      >
        <el-input
          v-model="userInfo.password"
          type="password"
          placeholder="请输入旧密码"
          show-password
        />
      </el-form-item>
      <el-form-item
        label="新密码"
        prop="newpassword"
        :rules="[{ required: true, message: '请输入新密码', trigger: 'blur' }]"
      >
        <el-input
          v-model="userInfo.newpassword"
          type="password"
          placeholder="请输入新密码"
          show-password
        />
      </el-form-item>
      <el-button type="primary" @click="userInfosubmitForm">提交</el-button>
    </el-form>
  </el-dialog>

  <!-- 上方两个tab -->
  <div class="mx-2.5 mt-2.5">
    <el-row :gutter="20">
      <el-col :span="12">
        <Card title="填写病案" description="填写病案详情" @click="click">
          <template v-slot:icon>
            <el-icon :size="30">
              <Edit />
            </el-icon>
          </template>
        </Card>
      </el-col>
      <el-col :span="12">
        <Card title="病案记录" :description="recordNum" @click="recordclick">
          <template v-slot:icon>
            <el-icon :size="30">
              <PieChart />
            </el-icon>
          </template>
        </Card>
      </el-col>
    </el-row>
  </div>

  <!-- 病案记录 -->
  <div class="mx-2.5 mt-2.5" v-if="index == 0">
    <div v-for="record in patientRecords" :key="record._id" class="record-card">
      <el-card class="record-card" shadow="hover">
        <h1 class="title">患者记录</h1>
        <div class="info-item">
          <p><strong>姓名:</strong> {{ record.patientName }}</p>
        </div>
        <div class="info-item">
          <p><strong>住院号:</strong> {{ record.patientNumber }}</p>
        </div>
        <div class="info-item">
          <p><strong>性别:</strong> {{ record.gender }}</p>
        </div>
        <div class="info-item">
          <p><strong>疾病:</strong> {{ Array.isArray(record.disease) ? record.disease.join(" ； ") : record.disease }}</p>
        </div>
        <div class="info-item">
          <p><strong>手术名称:</strong> {{ Array.isArray(record.surgery) ? record.surgery.join(" ； ") : record.surgery }}</p>
        </div>
        <div class="info-item">
          <p>
            <strong>治疗情况:</strong>
            {{ Array.isArray(record.treatment) ? record.treatment.map((group) => Array.isArray(group) ? group.join(" / ") : group).join("; ") : record.treatment }}
          </p>
        </div>
        <div class="info-item">
          <p>
            <strong>病理报告:</strong> {{ Array.isArray(record.pathologyReport) ? record.pathologyReport.join("; ") : record.pathologyReport }}
          </p>
        </div>

        <div class="info-item">
          <p>
            <strong>免疫组化类型:</strong>
            {{
              Array.isArray(record.ImmunohistochemistryType) 
                ? record.ImmunohistochemistryType.map((group) => 
                    Array.isArray(group) ? group.join(" / ") : group
                  ).join("; ")
                : record.ImmunohistochemistryType
            }}
          </p>
        </div>

        <div class="button-group">
          <el-button
            type="primary"
            @click="togglePhotos(record._id)"
            class="mb-2"
          >
            {{ activePhotoId === record._id ? "隐藏图片" : "查看照片" }}
          </el-button>
          <el-button type="success" @click="editRecord(record)" class="mb-2">
            编辑
          </el-button>
          <el-button type="danger" @click="confirmDelete(record)" class="mb-2">
            删除记录
          </el-button>
        </div>
        <div v-if="activePhotoId === record._id" class="image-gallery">
          <el-image
            :src="record.medicalPhoto[0]"
            :zoom-rate="1.2"
            :max-scale="7"
            :min-scale="0.2"
            :preview-src-list="record.medicalPhoto"
            :initial-index="0"
            fit="cover"
          />
        </div>
        <!-- 删除确认对话框@click="handleDeleteConfirm" -->
        <el-dialog v-model="deleteDialogVisible" title="确认删除" width="80%">
          <span>确定要删除该病例记录吗？此操作不可恢复。</span>
          <template #footer>
            <span class="dialog-footer">
              <el-button @click="deleteDialogVisible = false">取消</el-button>
              <el-button
                type="danger"
                @click="handleDeleteConfirm"
                :loading="deleteLoading"
              >
                确定删除
              </el-button>
            </span>
          </template>
        </el-dialog>
      </el-card>
    </div>
  </div>

  <!-- 编辑数据对话框 -->
  <el-dialog v-model="dialogVisible" width="96%">
    <el-form
      :model="form"
      ref="form"
      :rules="rules"
      label-width="120px"
      class="edit-form"
    >
      <h1 class="edittitle">编辑病案</h1>
      <el-form-item label="患者姓名" prop="patientName">
        <el-input
          v-model="form.patientName"
          placeholder="请输入姓名"
        ></el-input>
      </el-form-item>

      <el-form-item label="住院号" prop="patientNumber">
        <el-input
          v-model="form.patientNumber"
          placeholder="请输入住院号"
          @input="checkPatientNumber"
        ></el-input>
        <span v-if="patientNumberError" class="error-message">{{
          patientNumberError
        }}</span>
      </el-form-item>
      <!-- <el-form-item label="住院号" prop="patientNumber">
        <el-input
          v-model="form.patientNumber"
          placeholder="请输入住院号"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="性别" prop="gender">
        <el-select v-model="form.gender" placeholder="请选择性别">
          <el-option label="男" value="男"></el-option>
          <el-option label="女" value="女"></el-option>
        </el-select>
      </el-form-item>

      <SelectWithAdd
        v-model="form.disease"
        label="疾病"
        prop="disease"
        :options="diseases"
        multiple="true"
        placeholder="请选择疾病名称"
        :rules="[
          { required: false, message: '请选择疾病名称', trigger: 'change' },
        ]"
        @add-option="handleAddDisease"
      />

      <el-form-item label="治疗情况" prop="treatment">
        <el-cascader
          v-model="form.treatment"
          placeholder="请选择治疗情况"
          style="width: 100%"
          :options="treatments"
          :props="props"
          collapse-tags
          collapse-tags-tooltip
          max-collapse-tags="3"
          clearable
        />
      </el-form-item>

      <el-form-item label="治疗日期" prop="treatmenttime">
        <el-date-picker
          v-model="form.treatmenttime"
          type="datetime"
          placeholder="请选择日期"
          format="YYYY-MM-DD HH:mm:ss"
          date-format="MMM DD, YYYY"
          time-format="HH:mm"
          style="width: 100%"
        />
      </el-form-item>

      <SelectWithAdd
        v-model="form.surgery"
        label="手术名称"
        prop="surgery"
        :options="surgeries"
        multiple="true"
        placeholder="请选择手术名称"
        :rules="[
          { required: false, message: '请选择手术名称', trigger: 'change' },
        ]"
        @add-option="handleAddSurgery"
      />

      <SelectWithAdd
        v-model="form.pathologyReport"
        label="病理报告"
        prop="pathologyReport"
        :options="pathologyReports"
        multiple="true"
        placeholder="请选择病理类型"
        :rules="[{ required: false, message: '请选择科室', trigger: 'change' }]"
        @add-option="handleAddPathologyReport"
      />

      <el-form-item label="免疫组化类型" prop="ImmunohistochemistryType">
        <el-cascader
          v-model="form.ImmunohistochemistryType"
          placeholder="请选择免疫标志物类型"
          style="width: 100%"
          :options="options"
          :props="props"
          collapse-tags
          collapse-tags-tooltip
          max-collapse-tags="3"
          clearable
        />
      </el-form-item>
      <el-form-item label="上传图片" prop="medicalPhoto">
        <el-upload
          class="upload-demo"
          :on-change="handleChange"
          :before-upload="beforeUpload"
          :limit="12"
          :on-exceed="handleExceed"
          :file-list="editfileList"
          :on-remove="handleRemove"
          list-type="picture"
          :http-request="edituploadToLaf"
          multiple="true"
        >
          <div class="flex items-center">
            <el-button slot="trigger" size="small" type="primary"
              >选择文件</el-button
            >
            <el-tag
              type="info"
              slot="tip"
              v-if="editfileList.length === 0"
              class="ml-1"
              >最多上传12个文件,且不超过8MB</el-tag
            >
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="editsubmitForm">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
  <!-- 病案收集系统 -->
  <el-form
    :model="form"
    ref="form"
    :rules="rules"
    label-width="98px"
    class="referral-form"
    v-if="index == 1"
  >
    <h1 class="title">病案收集系统</h1>
    <el-form-item label="患者姓名" prop="patientName">
      <el-input v-model="form.patientName" placeholder="请输入姓名"></el-input>
    </el-form-item>
    <el-form-item label="住院号" prop="patientNumber">
      <el-input
        v-model="form.patientNumber"
        placeholder="请输入住院号"
        @input="checkPatientNumber"
      ></el-input>
      <span v-if="patientNumberError" class="error-message">{{
        patientNumberError
      }}</span>
    </el-form-item>
    <el-form-item label="性别" prop="gender">
      <el-select v-model="form.gender" placeholder="请选择性别">
        <el-option label="男" value="男"></el-option>
        <el-option label="女" value="女"></el-option>
      </el-select>
    </el-form-item>

    <SelectWithAdd
      v-model="form.disease"
      label="疾病"
      prop="disease"
      :options="diseases"
      placeholder="请选择疾病名称"
      multiple="true"
      :rules="[
        { required: false, message: '请选择疾病名称', trigger: 'change' },
      ]"
      @add-option="handleAddDisease"
    />

    <el-form-item label="治疗情况" prop="treatment" style="width: 100%">
      <!-- <div class="form-row">
        <el-date-picker
          v-model="form.treatmenttime"
          type="datetime"
          placeholder="请选择日期"
          format="YYYY-MM-DD HH:mm:ss"
          date-format="MMM DD, YYYY"
          time-format="HH:mm"
          style="flex: 0.8; margin-right: 10px"
        />
        <el-cascader
          v-model="form.treatment"
          placeholder="请选择治疗情况"
          style="flex: 1.4"
          :options="treatments"
          :props="props"
          collapse-tags
          collapse-tags-tooltip
          max-collapse-tags="1"
          clearable
          popper-class="full-width-cascader"
        />
      </div> -->
      <!-- <el-date-picker
        v-model="form.treatmenttime"
        type="datetime"
        placeholder="请选择日期"
        format="YYYY-MM-DD HH:mm:ss"
        date-format="MMM DD, YYYY"
        time-format="HH:mm"
        style="width: 100%"
      />-->
      <el-cascader
        v-model="form.treatment"
        placeholder="请选择治疗情况"
        style="width: 100%"
        :options="treatments"
        :props="props"
        collapse-tags
        collapse-tags-tooltip
        max-collapse-tags="3"
        clearable
        popper-class="full-width-cascader"
      />
    </el-form-item>

    <el-form-item label="治疗日期" prop="treatmenttime">
      <el-date-picker
        v-model="form.treatmenttime"
        type="datetime"
        placeholder="请选择日期"
        format="YYYY-MM-DD HH:mm:ss"
        date-format="MMM DD, YYYY"
        time-format="HH:mm"
        style="width: 100%"
      />
    </el-form-item>

    <SelectWithAdd
      v-model="form.surgery"
      label="手术名称"
      prop="surgery"
      :options="surgeries"
      placeholder="请选择手术名称"
      multiple="true"
      :rules="[
        { required: false, message: '请选择手术名称', trigger: 'change' },
      ]"
      @add-option="handleAddSurgery"
    />

    <SelectWithAdd
      v-model="form.pathologyReport"
      label="病理报告"
      prop="pathologyReport"
      :options="pathologyReports"
      placeholder="请选择病理类型"
      multiple="true"
      :rules="[{ required: false, message: '请选择科室', trigger: 'change' }]"
      @add-option="handleAddPathologyReport"
    />

    <el-form-item label="免疫组化类型" prop="ImmunohistochemistryType">
      <el-cascader
        v-model="form.ImmunohistochemistryType"
        placeholder="请选择免疫标志物类型"
        style="width: 100%"
        :options="options"
        :props="props"
        collapse-tags
        collapse-tags-tooltip
        max-collapse-tags="3"
        clearable
      />
    </el-form-item>

    <!-- 上传到自己的sealos服务器 -->
    <el-form-item label="上传图片" prop="medicalPhoto">
      <el-upload
        class="upload-demo"
        :on-change="handleChange"
        :before-upload="beforeUpload"
        :limit="12"
        :on-exceed="handleExceed"
        :file-list="fileList"
        list-type="picture"
        :http-request="uploadToLaf"
        multiple="true"
      >
        <div class="flex items-center">
          <el-button slot="trigger" size="small" type="primary"
            >选择文件</el-button
          >
          <el-tag
            type="info"
            slot="tip"
            v-if="fileList.length === 0"
            class="ml-1"
            >最多上传12张图片</el-tag
          >
        </div>
      </el-upload>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitForm">提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { BinganPatient, changeUserPassword } from "../../api/userApi"; // 提交患者资料请求函数
import {
  uploadImage,
  deleteImage,
  getwechatsignature,
  getwechatImage,
} from "../../api/image"; // 上传图片到sealos请求函数
import { getbinganConfig } from "@/api/bingan-config"; // 获取病案管理系统配置函数

import {
  getPatientInfo,
  deletePatientInfo,
  editPatientInfo,
} from "../../api/patientApi";
import Card from "../../components/card"; // 引入 Card 组件
import { mapActions, mapGetters } from "vuex";

//import { format } from "date-fns";
//import { diseases } from "./diseases";
//import { surgeries } from "./surgeries";
//import { pathologyReports } from "./pathologyReports";
import { ImmunohistochemistryTypes } from "./ImmunohistochemistryType";
import { treatments } from "./treatment";
import { hospitals } from "../RegistrationForm/hospitals";

import SelectWithAdd from "@/components/selectwithadd";
//import UploadImage from "@/components/UploadImage"; // 导入封装的上传组件
import wx from "weixin-js-sdk";

export default {
  name: "ReferralPatientForm",
  components: {
    Card, // 注册组件
    SelectWithAdd,
  },
  data() {
    return {
      index: 1,
      showMenu: false,
      isAdding: false,
      optionName: "",
      form: {
        patientName: "",
        patientNumber: "",
        gender: "",
        disease: [],
        treatment: [],
        treatmenttime: "",
        surgery: [],
        medicalPhoto: [],
        pathologyReport: [],
        ImmunohistochemistryType: [],
      },
      rules: {
        patientName: [
          { required: true, message: "请输入患者姓名", trigger: "blur" },
        ],
        patientNumber: [
          { required: true, message: "请输入患者住院号", trigger: "blur" },
          // {
          //   validator: (rule, value, callback) => {
          //     if (!value.startsWith("2025")) {
          //       callback(new Error("住院号必须以2025开头"));
          //     } else if (value.length > 12) {
          //       callback(new Error("住院号总长度不能超过12位"));
          //     } else if (!/^\d+$/.test(value.slice(4))) {
          //       callback(new Error("住院号必须以2025开头，跟随数字"));
          //     } else {
          //       callback();
          //     }
          //   },
          //   trigger: "blur",
          // },
        ],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        disease: [{ required: true, message: "请选择疾病", trigger: "change" }],
        treatment: [
          { required: false, message: "请选择治疗情况", trigger: "change" },
        ],
        treatmenttime: [
          { required: false, message: "请选择治疗日期", trigger: "change" },
        ],
        surgery: [
          { required: false, message: "请选择手术名称", trigger: "change" },
        ],
        medicalPhoto: [
          { required: false, message: "请上传病情照片", trigger: "change" },
        ],
        pathologyReport: [
          { required: false, message: "请选择病理结果", trigger: "blur" },
        ],
        ImmunohistochemistryType: [
          { required: false, message: "请选择免疫标志物类型", trigger: "blur" },
        ],
      },
      userInfo: {
        hospital: "",
        keshi: "",
        name: "",
        sex: "",
        zhicheng: "",
        phone: "",
        password: "",
        newpassword: "",
      },
      fileList: [],
      fileListOne: [],
      editfileList: [],
      diseases: [], // 修改这行，直接使用导入的数组
      surgeries: [],
      treatments: treatments,
      pathologyReports: [],
      recordNum: "记录总数",

      patientRecords: [],
      activePhotoId: null, // 当前活动的照片 ID
      dialogVisible: false, // 控制对话框的显示
      currentPhotoUrls: [], // 当前显示的照片 URL 列表
      currentPhotoUrl: "", // 当前显示的照片 URL
      previewUrl: "", // 当前预览的照片 URL
      enlargedImageUrl: "", // 当前放大的图片 URL
      patientNumberError: "", // To store the error message

      deleteDialogVisible: false,
      deleteLoading: false,
      recordToDelete: null,

      hospitals,
      userInfodialogVisible: false, //控制修改个人信息对话框的显示

      props: { multiple: true },
      options: ImmunohistochemistryTypes,

      checkboxGroup2: ["Shanghai"],
      cities: ["Shanghai", "Beijing", "Guangzhou", "Shenzhen"],
    };
  },
  computed: {
    ...mapGetters(["userInfo", "patientRecords", "setUserInfo"]), // 从 Vuex 获取用户信息和患者记录
  },
  async created() {
    // 从路由中获取用户信息
    this.userInfo = this.$route.query; // 假设 userInfo 是一个对象
    console.log("ReferralPatient created", this.userInfo);

    // 从路由的 query 中获取 userInfo 并解析为对象
    // this.userInfo = JSON.parse(this.$route.query);
    // console.log("Received userInfo:", this.userInfo);

    // if (this.userInfo) {
    //   await this.setUserInfo(this.userInfo); // 将用户信息存入 Vuex
    // }

    try {
      const [diseasesResponse, surgeriesResponse, pathologyreportsResponse] =
        await Promise.all([
          getbinganConfig("getdiseases"),
          getbinganConfig("getsurgeries"),
          getbinganConfig("getpathologyreports"),
        ]);
      console.log(
        "API Responses:",
        diseasesResponse,
        surgeriesResponse,
        pathologyreportsResponse
      );
      this.diseases = diseasesResponse.data.diseases;
      this.surgeries = surgeriesResponse.data.surgeries;
      this.pathologyReports = pathologyreportsResponse.data.pathologyreports;
      // 使用 await 获取实际数据
      this.patientRecords = await this.getpatientRecords();
      console.log("患者记录:", this.patientRecords);
      console.log("患者记录总数:", this.patientRecords.length);
      const string = `记录总数:${this.patientRecords.length}条`;
      this.recordNum = string;
      console.log("患者记录:", this.patientRecords);
    } catch (error) {
      console.error("获取患者记录时出错:", error);
    }
  },
  mounted() {
    //this.initWechatSDK();
  },
  methods: {
    ...mapActions(["login", "logout", "setUserInfo", "setPatientRecords"]),

    checkPatientNumber() {
      const value = this.form.patientNumber;
      if (value === "") {
        this.patientNumberError = ""; // Clear error if input is empty
      } 
      //else if (!value.startsWith("2025")) {
        //this.patientNumberError = "住院号必须以2025开头";
      //} 
      //else if (value.length > 12) {
        //this.patientNumberError = "住院号总长度不能超过12位";
      //} 
      else if (!/^\d+$/.test(value)) {
        this.patientNumberError = "住院号必须为数字";
      } else {
        this.patientNumberError = "";
      }
    },
    async initWechatSDK() {
      try {
        const currentUrl = encodeURIComponent(window.location.href);
        console.log(currentUrl);

        const query = {
          params: {
            flag: "wechatsignature",
            url: currentUrl,
          },
        };
        const res = await getwechatsignature(query);
        console.log("res", res);

        const { appId, timestamp, nonceStr, signature } = res.data;

        wx.config({
          debug: true,
          appId,
          timestamp,
          nonceStr,
          signature,
          jsApiList: ["chooseImage", "uploadImage"],
        });
        wx.ready(() => {
          console.log("微信JS-SDK配置成功");
          wx.checkJsApi({
            jsApiList: ["chooseImage"],
            success: (res) => {
              if (res.checkResult.chooseImage) {
                console.log("支持 chooseImage 接口");
                // 调用 chooseImage 接口
                wx.chooseImage({
                  count: 9, // 最多可以选择9张图片
                  sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图
                  sourceType: ["album", "camera"], // 可以指定来源是相册还是相机
                  success: (res) => {
                    const localIds = res.localIds; // 返回选定照片的本地ID列表
                    console.log("选择的图片本地ID:", localIds);
                    this.uploadImages(localIds); // 上传图片
                  },
                  fail: (err) => {
                    console.error("选择图片失败", err);
                  },
                });
              } else {
                console.log("不支持 chooseImage 接口");
              }
            },
          });
        });

        wx.error((err) => {
          console.error("微信JS-SDK配置失败", err);
        });
      } catch (error) {
        console.error("获取微信签名失败", error);
      }
    },
    chooseImageFromWechat() {
      console.log("选择图片");

      wx.ready(() => {
        wx.chooseImage({
          count: 9, // 最多可以选择9张图片
          sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
          success: (res) => {
            console.log(res);

            const localIds = res.localIds; // 返回选定照片的本地ID列表
            this.uploadImages(localIds);
          },
          fail: (err) => {
            console.error("选择图片失败", err);
          },
        });
      });
    },

    async uploadImages(localIds) {
      for (const localId of localIds) {
        wx.uploadImage({
          localId,
          isShowProgressTips: 1,
          success: (res) => {
            const serverId = res.serverId;
            this.handleWechatImage(serverId);
          },
          fail: (err) => {
            console.error("上传图片失败", err);
          },
        });
      }
    },
    async handleWechatImage(serverId) {
      try {
        const res = await getwechatImage(serverId);
        console.log("res", res);
        const imageUrl = res.data.imageUrl;
        this.form.medicalPhoto.push(imageUrl);
      } catch (error) {
        console.error("获取图片URL失败", error);
      }
    },

    async getpatientRecords() {
      const res = await getPatientInfo(
        this.userInfo.name,
        this.userInfo.keshi,
        this.userInfo.hospital
      );
      return res.data;
    },

    getInitialFormState() {
      return {
        patientName: "",
        patientNumber: "",
        gender: "",
        disease: "",
        surgery: "",
        medicalPhoto: [],
        pathologyReport: "",
        ImmunohistochemistryType: "",
        treatment: "",
        fileList: [],
      };
    },
    resetForm() {
      this.form = this.getInitialFormState();
    },

    recordclick() {
      this.index = 0;
      this.resetForm();
    },
    click() {
      this.index = 1;
      this.resetForm();
    },

    handleChange(file, fileList) {
      this.fileList = fileList;
      this.editfileList = fileList;
      // if (this.form.medicalPhoto && Array.isArray(this.form.medicalPhoto)) {
      //   this.form.medicalPhoto = fileList.map(file => file.url)
      // }

      // console.log(
      //   "图片改变信息",
      //   this.form.medicalPhoto
      // );
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过8MB!");
      }
      return isJPG && isLt2M;
    },
    handleExceed(files) {
      this.$message.warning(
        `最多上传12张图片，当前选择了 ${files.length} 个文件`
      );
    },

    // async delimage(data) {
    //   await deleteImage(data);
    // },

    handleRemove(file) {
      // 从 fileList 中删除对应的图片
      const index = this.editfileList.findIndex(
        (item) => item.uid === file.uid
      );

      // this.delimage({
      //   flag: "deleteimage",
      //   url: this.fileList[index].url,
      // });
      //console.log("被删除的图片", this.fileList[index].url);
      if (index !== -1) {
        this.editfileList.splice(index, 1);

        console.log("旧数组", this.form.medicalPhoto);

        // 同时更新 form.medicalPhoto 数组
        if (this.form.medicalPhoto && Array.isArray(this.form.medicalPhoto)) {
          this.form.medicalPhoto = this.editfileList.map((file) => file.url);
        }

        // 可选：显示删除成功提示
        this.$message({
          type: "success",
          message: "图片已删除",
        });
      }
    },

    formattime() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // 月份从0开始，所以加1
      const day = String(today.getDate()).padStart(2, "0");
      const formattedDate = `${year}${month}${day}`;
      //console.log("formattedDate", formattedDate); // 输出格式为：YYYY-MM-DD
      return formattedDate;
    },
    // upload组件自定义上传到 LAF 的请求
    async uploadToLaf({ file, onSuccess, onError }) {
      try {
        //console.log("file列表", file);
        let formData = new FormData();
        formData.append("file", file);
        formData.append("flag", "file");

        let time = this.formattime();
        //上传到sealos对象存储
        let path = `病案收集系统/${this.userInfo.name}/${time}`;
        //console.log(path);

        formData.append("filepath", path);

        // 上传文件并获取永久链接
        const res = await uploadImage(formData);
        console.log("图片上传情况", res.data[0].url);

        // 确保 medicalPhoto 是数组
        if (!Array.isArray(this.form.medicalPhoto)) {
          this.form.medicalPhoto = [];
        }

        // 如果上传成功，添加新图片URL
        if (res.data && res.data[0].url) {
          this.form.medicalPhoto.push(res.data[0].url);
        }

        // 将上传成功的 URL 添加到 medicalPhoto 数组中
        //this.form.medicalPhoto.push(res.data[0].url);

        console.log("medicalPhoto", this.form.medicalPhoto);
        onSuccess(res.data); // 调用成功回调
      } catch (error) {
        onError(error);
      }
    },

    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.checkPatientNumber();
          if (this.patientNumberError) {
            this.$message.error(this.patientNumberError);
            return; // Stop submission if there's an error
          }
          const formData = new FormData();

          formData.append("patientName", this.form.patientName);
          formData.append("patientNumber", this.form.patientNumber);
          formData.append("gender", this.form.gender);
          // formData.append("disease", this.form.disease);
          // formData.append("surgery", this.form.surgery);
          // formData.append("pathologyReport", this.form.pathologyReport);

          formData.append("disease", JSON.stringify(this.form.disease));
          formData.append("surgery", JSON.stringify(this.form.surgery));
          formData.append(
            "pathologyReport",
            JSON.stringify(this.form.pathologyReport)
          );
          formData.append(
            "ImmunohistochemistryType",
            JSON.stringify(this.form.ImmunohistochemistryType)
          );

          formData.append("treatment", JSON.stringify(this.form.treatment));
          formData.append("treatmenttime", this.form.treatmenttime);
          // if (this.form.medicalPhoto) {
          //   formData.append("medicalPhoto", this.form.medicalPhoto);
          // }
          // 直接使用数组
          //formData.append("medicalPhoto", this.form.medicalPhoto);

          formData.append(
            "medicalPhoto",
            JSON.stringify(this.form.medicalPhoto)
          );
          // 添加 userInfo 信息
          formData.append("hospital", this.userInfo.hospital);
          formData.append("keshi", this.userInfo.keshi);
          formData.append("name", this.userInfo.name);
          formData.append("zhicheng", this.userInfo.zhicheng);
          formData.append("userPhone", this.userInfo.phone);

          console.log("this.form", this.form);

          try {
            formData.forEach((value, key) => {
              console.log(`${key}: ${value}`);
            });

            const result = await BinganPatient(formData); // 使用 axios 发送请求

            this.$message({
              type: "success",
              message: "提交成功",
            });
            // 将 userInfo 的属性合并到 form 对象中,用editPatientInfo直接提交到sealos
            // this.form = {
            //   ...this.form,
            //   hospital: this.userInfo.hospital,
            //   keshi: this.userInfo.keshi,
            //   name: this.userInfo.name,
            //   zhicheng: this.userInfo.zhicheng,
            //   userPhone: this.userInfo.phone,
            // };
            //const result = await editPatientInfo(this.form._id, this.form); // 使用 axios 发送请求

            console.log(result);

            //alert(result.message);

            // 使用 await 获取实际数据
            this.patientRecords = await this.getpatientRecords();
            console.log("患者记录总数:", this.patientRecords.length);
            const string = `记录总数:${this.patientRecords.length}条`;
            this.recordNum = string;
            this.recordclick();
            this.fileList = [];
            this.resetForm();
          } catch (error) {
            alert("提交失败，请重试");
          }
        } else {
          console.log("表单验证失败!");
          return false;
        }
      });
    },

    editRecord(record) {
      console.log("Edit record:", record);
      this.dialogVisible = true;

      // 将 proxy 数组转换为普通数组
      const medicalPhoto = record.medicalPhoto ? [...record.medicalPhoto] : [];

      // 创建符合 el-upload 要求的文件列表格式
      this.editfileList = medicalPhoto.map((url, index) => ({
        name: `图片${index + 1}`,
        url: url,
        uid: -(index + 1), // el-upload 需要唯一的 uid
      }));

      this.form = {
        ...record,
        medicalPhoto,
      };
      console.log("Edit form:", this.form, medicalPhoto);
    },
    async deleteRecord(record) {
      // Implement delete functionality
      console.log("Delete record:", record);
      await deletePatientInfo(record._id);
      this.patientRecords = await this.getpatientRecords();
      console.log("患者记录总数:", this.patientRecords.length);
      const string = `记录总数:${this.patientRecords.length}条`;
      this.recordNum = string;
      console.log("患者记录:", this.patientRecords);
      //console.log(res);
    },

    // upload组件自定义上传到 LAF 的请求
    async edituploadToLaf({ file, onSuccess, onError }) {
      try {
        console.log("file列表", file);
        let formData = new FormData();
        formData.append("file", file);
        formData.append("flag", "file");

        let time = this.formattime();
        //上传到sealos对象存储
        let path = `病案收集系统/${this.userInfo.name}/${time}`;
        console.log(path);

        formData.append("filepath", path);

        // 上传文件并获取永久链接
        const res = await uploadImage(formData);
        console.log("图片上传情况", res.data[0].url);

        // 确保 medicalPhoto 是数组
        if (!Array.isArray(this.form.medicalPhoto)) {
          this.form.medicalPhoto = [];
        }

        // 将上传成功的 URL 添加到 medicalPhoto 数组中
        this.form.medicalPhoto.push(res.data[0].url);

        console.log("medicalPhoto", this.form.medicalPhoto);
        onSuccess(res.data); // 调用成功回调
      } catch (error) {
        onError(error);
      }
    },
    async editsubmitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.checkPatientNumber();
          if (this.patientNumberError) {
            this.$message.error(this.patientNumberError);
            return; // Stop submission if there's an error
          }
          const formData = new FormData();

          formData.append("patientName", this.form.patientName);
          formData.append("patientNumber", this.form.patientNumber);
          formData.append("gender", this.form.gender);
          formData.append("disease", this.form.disease);
          formData.append("surgery", this.form.surgery);
          formData.append("pathologyReport", this.form.pathologyReport);
          formData.append(
            "ImmunohistochemistryType",
            this.form.ImmunohistochemistryType
          );

          formData.append("treatment", this.form.treatment);
          formData.append("treatmenttime", this.form.treatmenttime);
          if (this.form.medicalPhoto) {
            formData.append("medicalPhoto", this.form.medicalPhoto);
          }
          // 添加 userInfo 信息
          formData.append("hospital", this.userInfo.hospital);
          formData.append("keshi", this.userInfo.keshi);
          formData.append("name", this.userInfo.name);
          formData.append("zhicheng", this.userInfo.zhicheng);
          formData.append("userPhone", this.userInfo.phone);

          try {
            const result = await editPatientInfo(this.form._id, this.form); // 使用 axios 发送请求

            this.$message({
              type: "success",
              message: "资料修改成功",
            });
            console.log("******************", result);
            this.patientRecords = await this.getpatientRecords();
            console.log("患者记录总数:", this.patientRecords.length);
            const string = `记录总数:${this.patientRecords.length}条`;
            this.recordNum = string;
            this.recordclick();
            this.dialogVisible = false;
            this.fileList = [];
            this.resetForm();
          } catch (error) {
            alert("提交失败，请重试");
          }
        } else {
          console.log("表单验证失败!");
          return false;
        }
      });
    },

    togglePhotos(recordId) {
      this.activePhotoId = this.activePhotoId === recordId ? null : recordId;
    },

    exit() {
      this.$message({
        type: "success",
        message: "退出成功",
      });
      this.logout();
      this.$router.push("/");
    },

    //控制修改个人信息对话框的显示
    changepassword() {
      this.userInfodialogVisible = true;
    },

    validateRegisterForm() {
      // 检查每个字段是否已填写
      return (
        this.userInfo.hospital &&
        this.userInfo.keshi &&
        this.userInfo.name &&
        this.userInfo.zhicheng &&
        this.userInfo.phone &&
        this.userInfo.sex &&
        this.userInfo.password &&
        this.userInfo.newpassword
      );
    },
    async userInfosubmitForm() {
      // 验证表单字段是否完整
      const isFormValid = this.validateRegisterForm();
      if (!isFormValid) {
        this.$message({
          type: "warning",
          message: "请确保所有字段都已填写完整。",
        });
        return;
      }

      try {
        //console.log("患者新资料信息:", this.userInfo);
        const result = await changeUserPassword(this.userInfo); // 使用 axios 发送请求
        //console.log("服务器返回修改结果", result);

        this.$message({
          type: "success",
          message: "密码修改成功,请重新登录",
        });
        this.userInfodialogVisible = false;
        this.logout();
        this.$router.push("/");
      } catch (error) {
        this.$message({
          type: "error",
          message: error.message || "注册失败，请重试",
        });
      }
    },

    //处理自行添加数据选项的函数
    handleAddPathologyReport(newOption) {
      const newValue = {
        value: newOption,
        label: newOption,
      };
      this.pathologyReports.unshift(newValue);
      this.form.pathologyReport = newOption;
    },

    handleAddDisease(newOption) {
      const newValue = {
        value: newOption,
        label: newOption,
      };
      this.diseases.unshift(newValue);
      this.form.disease = newOption;
    },

    handleAddSurgery(newOption) {
      const newValue = {
        value: newOption,
        label: newOption,
      };
      this.surgeries.unshift(newValue);
      this.form.surgery = newOption;
    },

    //跳出是否删除对话框
    async confirmDelete(record) {
      this.recordToDelete = record;
      this.deleteDialogVisible = true;
    },

    //删除记录
    async handleDeleteConfirm() {
      if (!this.recordToDelete) return;

      this.deleteLoading = true;
      try {
        console.log("Delete record:", this.recordToDelete._id);
        await deletePatientInfo(this.recordToDelete._id);

        this.$message({
          type: "success",
          message: "删除成功",
        });
        this.patientRecords = await this.getpatientRecords();
        console.log("患者记录总数:", this.patientRecords.length);
        const string = `记录总数:${this.patientRecords.length}条`;
        this.recordNum = string;
        console.log("患者记录:", this.patientRecords);
      } catch (error) {
        this.$message({
          type: "error",
          message: "删除失败，请重试",
        });
        console.error("Delete failed:", error);
      } finally {
        this.deleteLoading = false;
        this.deleteDialogVisible = false;
        this.recordToDelete = null;
      }
    },

    // 更新父组件中的文件列表
    // updateFileList(newFileList) {
    //   this.fileList = newFileList;
    // },

    // handleChangeOne(file, fileList) {
    //   console.log("图片改变信息", file, fileList);
    // },
    // beforeUploadOne(file) {
    //   const isJPG = file.type === "image/jpeg" || file.type === "image/png";
    //   const isLt2M = file.size / 1024 / 1024 < 50;
    //   if (!isJPG) {
    //     this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
    //   }
    //   if (!isLt2M) {
    //     this.$message.error("上传图片大小不能超过8MB!");
    //   }
    //   return isJPG && isLt2M;
    // },
    // handleExceedOne(files) {
    //   this.$message.warning(
    //     `最多上传12张图片，当前选择了 ${files.length} 个文件`
    //   );
    // },

    // handleSuccessOne(response, file) {
    //   console.log("response", response);

    //   this.fileListOne.push({
    //     name: file.name,
    //     url: response.url,
    //     filename: response.filename,
    //   });
    //   // 确保 medicalPhoto 是数组
    //   if (!Array.isArray(this.form.medicalPhoto)) {
    //     this.form.medicalPhoto = [];
    //   }
    //   // 将上传成功的 URL 添加到 medicalPhoto 数组中
    //   this.form.medicalPhoto.push(response.url);
    //   console.log("medicalPhoto", this.form.medicalPhoto);
    // },

    // async handleRemoveOne(file) {
    // },

    // AddOption() {
    //   this.isAdding = true;
    // },
    // onSurgeryConfirm() {
    //   if (this.optionName) {
    //     this.surgeries.unshift({
    //       label: this.optionName,
    //       value: this.optionName,
    //     });
    //     this.clear();
    //   }
    // },
    // onDiseaseConfirm() {
    //   if (this.optionName) {
    //     this.diseases.unshift({
    //       label: this.optionName,
    //       value: this.optionName,
    //     });
    //     this.clear();
    //   }
    // },
    // onPathologyReportConfirm() {
    //   if (this.optionName) {
    //     this.pathologyReports.unshift({
    //       label: this.optionName,
    //       value: this.optionName,
    //     });
    //     this.clear();
    //   }
    // },

    // clear() {
    //   this.optionName = "";
    //   this.isAdding = false;
    // },
  },
  // computed: {
  //   currentPhotoUrl() {
  //     return this.currentPhotoUrls[this.currentPhotoIndex]; // 返回当前照片的 URL
  //   },
  // },
};
</script>

<style lang="scss" scoped>
h1 {
  margin-bottom: 20px;
}

.title {
  @apply bg-blue-100 text-blue-800 border-l-4 border-blue-500 p-4 rounded-lg shadow-md;
}

.edittitle {
  @apply bg-blue-100 text-blue-800 border-l-4 border-blue-500 p-2 rounded-lg shadow-md mt-2;
}

.user-info {
  position: relative;
  /* 使下拉菜单相对定位 */
  margin: 10px;
  margin-top: 16px;
}

.user-info-header {
  display: flex;
  /* 使用 flex 布局 */
  justify-content: space-between;
  /* 左右对齐 */
  align-items: center;
  /* 垂直居中对齐 */
}

.user-dropdown {
  margin-left: 10px;
}

.referral-form {
  margin: 10px 10px;

  padding: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.record-card {
  border-radius: 8px;
  background-color: #fff;
  margin-bottom: 12px;
}

.record-title {
  font-size: 20px;
  margin: 0 0 10px 0;
}

.image-gallery {
  display: flex;
  flex-wrap: wrap;
  /* 允许换行 */
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  /* 按钮两端对齐 */
}

.info-item {
  border: 1px solid #e0e0e0;
  /* 添加边框 */
  padding: 10px;
  /* 添加内边距 */
  margin-bottom: 10px;
  /* 添加底部间距 */
  border-radius: 5px;
  /* 添加圆角 */
  background-color: #f9f9f9;
  /* 添加背景色 */
}

.preview-area {
  margin-top: 20px;
  border: 1px solid #e0e0e0;
  /* 添加边框 */
  padding: 10px;
  /* 添加内边距 */
  background-color: #f9f9f9;
  /* 添加背景色 */
}

.button-group {
  display: flex;
  gap: 10px;
  /* Adjust the gap between buttons as needed */
}

.option-input {
  width: 100%;
  margin-bottom: 8px;
}

.dialog-footer {
  @apply flex justify-end gap-2;
}

.full-width-cascader .el-cascader-menu {
  width: 100% !important;
}

.form-row {
  display: flex;
  width: 100%; /* Ensure the container is 100% wide */
  align-items: center;
  justify-content: space-between;
}

.error-message {
  color: red;
  font-size: 12px;
}
</style>
